import React from 'react';

import { PrismicRichText } from '@prismicio/react';

import '../assets/scss/treatment.scss';

const Treatment= (props) => {
    const { title, description } = props;

    if (!title && !description) return <></>;

    return (
        <div className="treatment">
            {title && (
                <PrismicRichText field={title} />
            )}

            {description && (
                <PrismicRichText field={description} />
            )}
        </div>
    )
};

export default Treatment;